export const verifyPanNumber = async (panNumber: string) => {
  const url = "https://kyc-api.aadhaarkyc.io/api/v1/pan/pan";
  
  const body = JSON.stringify({
    id_number: panNumber,
  });

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${process.env.REACT_APP_SUREPASS_API_TOKEN}`,
      },
      body: body,
    });
    const data = await response.json();
    return { status_code: response.status, full_name: data?.data?.full_name };
  } catch (error) {
    console.error("Error:", error);
  }
};

export const verifyGstNumber = async (gstNumber: string) => {
    const url = "https://kyc-api.aadhaarkyc.io/api/v1/corporate/gstin";
    
    const body = JSON.stringify({
      id_number: gstNumber,
      filing_status_get: true
    });
  
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${process.env.REACT_APP_SUREPASS_API_TOKEN}`,
        },
        body: body,
      });
      const data = await response.json();
        if (data?.status_code === 200) return {status: true, business_name: data?.data?.business_name, pan_number: data?.data?.pan_number};
        else return {status: false, business_name: ''};
    } catch (error) {
      console.error("Error:", error);
    }
  };